import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import ReadonlyLinkedShowsPanelSegment from "document/linkshow/ReadonlyLinkedShowsPanelSegment";
import { InvoiceV2InfoSection } from "InvoiceV2/components/DocumentDetails/InvoiceV2InfoSection";
import PaymentPanelSegment from "invoice/makepayment/PaymentsPanel";
import React from "react";
import TwoColumnLayout from "../../layout/TwoColumnLayout";
import ReadonlyProductsPanelSegment from "../../Products/ReadonlyProductsPanelSegment";
import InvoiceActivityPanel from "../components/activity/InvoiceActivityPanel";
import InvoiceV2OptionsPanel from "../components/optionspanel/InvoiceV2OptionsPanel";
import NotesPanel from "note/list/app";
import RecipientsPanel from "InvoiceV2/panelsegment/RecipientsPanel";
import { isPanelVisible } from "utilities/panelUtils";
interface Props {
  viewModel: server.viewmodel.InvoiceV2DetailFrontModel
}

const SettledPanel = (props: Props) => {
  const { viewModel } = props;

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <SectionPanel.Section>
        <InvoiceV2InfoSection
          invoice={viewModel.details}
          bookkeeping={viewModel.bookkeeping}
          productsByParent={viewModel.productsPanel.data}
          stepOptions={{
            draft: { disabled: true },
            review: { disabled: true },
            pending: { disabled: true },
            completed: { disabled: false }
          }}
          activeStep="completed"
          invoiceSent={viewModel.invoiceSent}
        />

        <PaymentPanelSegment
          useSectionPanel
          invoice={viewModel.details}
          canModify={viewModel.canModifyPayments}
        />

        <RecipientsPanel
          initialViewers={viewModel.recipients}
          invoice={viewModel.details}
        />

        <ReadonlyProductsPanelSegment
          productsPanel={viewModel.productsPanel}
        />

        {isPanelVisible(viewModel.linkedShowsPanel.config) && <ReadonlyLinkedShowsPanelSegment
          documentType="invoice"
          linkedShowsPanel={viewModel.linkedShowsPanel}
        />}

        <NotesPanel
          mainArea={"invoice"}
          useSectionPanel
          config={viewModel.linkedNotePanelConfig}
        />
      </SectionPanel.Section>
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <InvoiceV2OptionsPanel
        viewModel={viewModel}
      />
      <InvoiceActivityPanel
        documentId={viewModel.details.invoiceId}
        config={viewModel.activityPanelConfig}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>;
};

export default SettledPanel;